import { useMutation } from 'react-query';
import { paymentsSubscriptions } from '@/api/payment';

export const usePaymentSubscriptions = () => {
  return useMutation(paymentsSubscriptions);
};
